@if (showFilters$ | async) {
  <header class="tc-clones-header" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">
    @if (showSupplierFilter$ | async) {
      <tc-select-search placeholder="Supplier" [multiple]="true"
        [group]="filtersForm" ctrlName="supplierId"
        [items]="suppliers$ | async"
        bindValue="account"
        bindLabel="name"
      ></tc-select-search>
    }
    @if (showBuyerFilter$ | async) {
      <tc-select-search placeholder="Buyer" [multiple]="true"
        [group]="filtersForm" ctrlName="buyerId"
        [items]="buyers$ | async"
        bindValue="account"
        bindLabel="name"
      ></tc-select-search>
    }
    <span fxFlex></span>
  </header>
}

@if (canClone$ | async) {
  <div class="tc-clones-empty">
    <button type="button" mat-raised-button color="primary" (click)="showCloneDeal()">Clone</button>
  </div>
}

<tc-deals-list
  navigateTo="/trading/deals"
  [dataSource]="dataSource"
  [availableColumns]="displayColumns"
  [columnNames]="columnNames"
  [displayColumns]="displayColumns"
  [tableIdentity]="tableIdentity"
></tc-deals-list>
